'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var styles = _ref.styles;
  var measures = _ref2.measures,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale;

  var baseStyles = {
    root: {
      display: 'block',
      position: 'relative',
      marginBottom: rhythm(1)
    },

    video: {
      textAlign: 'center'
    },

    clear: {
      marginTop: rhythm(0.5),
      fontSize: scale(-1),
      textDecoration: 'underline',
      opacity: 0.5
    },

    note: {
      display: 'block',
      margin: rhythm([-0.5, 0, 1]),
      fontSize: scale(-1),
      lineHeight: measures.medium,
      opacity: 0.5
    }
  };

  return (0, _merge2.default)(baseStyles, styles);
};